import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardFeatureContent from "./CardFeatureContent";
import { CARD_FEATURE_DATA } from "../../constants/cardFeatureData";
import { sliderSetting } from "../../constants/sliderSetting";

function CardFeatures() {
  return (
    <>
      <section>
        <div className="feature-card">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="secondry-heading">
                  Why should you choose FlexiCash?
                </h2>
                <div className="card-main">
                  <div className="cb-wrap">
                    <Slider {...sliderSetting.verticalSlider}>
                      {CARD_FEATURE_DATA.map((item) => (
                        <CardFeatureContent
                          key={item.id}
                          cardFeatureIcon={item.cardFeatureIcon}
                          cardFeatureTitle={item.cardFeatureTitle}
                          cardFeatureSummary={item.cardFeatureSummary}
                        />
                      ))}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CardFeatures;
